import { Construction } from "lucide-react";
import "../../styles/pages/professional/ComingSoon.css";

function ComingSoon({
  title = "Coming Soon",
  description = "This module is currently being developed.",
}) {
  return (
    <main className="professional-coming-soon">
      <div className="professional-coming-soon-card">
        <div className="professional-coming-soon-icon">
          <Construction size={30} />
        </div>

        <p className="professional-coming-soon-eyebrow">
          ZETH HEALTH PROFESSIONAL PORTAL
        </p>

        <h1>{title}</h1>

        <p>{description}</p>
      </div>
    </main>
  );
}

export default ComingSoon;